import {usePromotion} from '@/context/Promotion/PromotionContext'

export const useSegmentsGroup = () => {
  const {
    onResultChange: updatePromotion,
    promotion: {segmentConfiguration},
  } = usePromotion()

  const handleDeleteGroup = index => {
    const updatedSegmentConfig = {
      ...segmentConfiguration,
      includedSegments: segmentConfiguration.includedSegments.filter((_, i) => i !== index),
    }
    updatePromotion({segmentConfiguration: updatedSegmentConfig})
  }

  const handleRemove = (segmentId, groupIndex) => {
    if (groupIndex === null) {
      const updatedExcludedSegments =
        segmentConfiguration.excludedSegment?.segments?.filter(segment => segment.segmentId !== segmentId) || []
      const updatedSegmentConfig = {
        ...segmentConfiguration,
        excludedSegment: {
          ...segmentConfiguration.excludedSegment,
          segments: updatedExcludedSegments,
        },
      }
      updatePromotion({segmentConfiguration: updatedSegmentConfig})
      return
    }

    const updatedIncludedSegments = segmentConfiguration.includedSegments.map((group, index) => {
      if (index === groupIndex) {
        return {
          ...group,
          segments: group.segments.filter(segment => segment.segmentId !== segmentId),
        }
      }
      return group
    })
    const updatedSegmentConfig = {
      ...segmentConfiguration,
      includedSegments: updatedIncludedSegments,
    }
    updatePromotion({segmentConfiguration: updatedSegmentConfig})
  }

  return {handleDeleteGroup, handleRemove}
}
